import React from 'react';
import { Skeleton } from '@shared/components/Skeleton';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { StyledDivider, styles } from '../../RegistryGiftCountsShop.styles';

export const GiftCountsSkeleton = () => {
  return (
    <Flex
      justifyContent="center"
      height="100%"
      alignItems="center"
    >
      <Flex
        marginRight={7}
        alignItems="center"
      >
        <Skeleton
          width={pxToRem(48)}
          height={pxToRem(48)}
          marginRight={3}
        />
        <Skeleton
          width={pxToRem(220)}
          height={pxToRem(32)}
        />
      </Flex>
      <Flex flexDirection="column">
        <Skeleton
          width={pxToRem(392)}
          height={pxToRem(32)}
          marginBottom={3}
        />
        <Skeleton
          width={pxToRem(392)}
          height={pxToRem(16)}
        />
      </Flex>
      <StyledDivider __css={styles.divider} />
    </Flex>
  );
};
